import { Component, Input, OnDestroy } from '@angular/core';
import {
    isDefined,
    ModalClass,
    SmartlockerDeliveryStatus,
    STATUS_ICONS,
    STATUS_ICONS_CLASSES,
} from '@evorait/pace-core';
import { faBox, faChevronDown, faChevronUp, faCogs, faExclamation } from '@fortawesome/free-solid-svg-icons';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SmartlockerAccessCodeComponent } from '../../smartlocker-access-code/smartlocker-access-code.component';
import { Subject, take } from 'rxjs';
import { SmartlockerTransferComponent } from '../../smartlocker-transfer/smartlocker-transfer.component';
import { Delivery, SmartlockerMaterial } from '../../../interfaces/smartlocker-deliveries.interface';
import { SmartlockerService } from '../../../services/smartlocker.service';

@Component({
    selector: 'pace-smartlocker-delivery',
    templateUrl: './smartlocker-delivery.component.html',
    styleUrls: ['./smartlocker-delivery.component.scss'],
    standalone: false,
})
export class SmartlockerDeliveryComponent implements OnDestroy {
    @Input() public smartlockerDelivery: Delivery;

    public isCollapsed = true;
    public readonly statusIcons = STATUS_ICONS;
    public readonly statusIconClasses = STATUS_ICONS_CLASSES;

    protected readonly faChevronUp = faChevronUp;
    protected readonly faChevronDown = faChevronDown;
    protected readonly faCogs = faCogs;
    protected readonly faBox = faBox;
    protected readonly faExclamation = faExclamation;
    protected readonly SmartlockerDeliveryStatus = SmartlockerDeliveryStatus;
    private destroy$ = new Subject<void>();

    public constructor(
        private readonly smartlockerService: SmartlockerService,
        private readonly modalService: BsModalService,
    ) {}

    public get showTransferAllButton(): boolean {
        return this.smartlockerDelivery.SmartlockerMaterials.some(
            (material: SmartlockerMaterial) =>
                material.Status === SmartlockerDeliveryStatus.Delivered ||
                material.Status === SmartlockerDeliveryStatus.InTransit,
        );
    }

    public setSelectedDelivery(delivery: Delivery): void {
        this.smartlockerService.setSelectedDelivery(delivery);
    }

    public launchTransferModal(material?: SmartlockerMaterial): void {
        const delivery = this.smartlockerService.getSelectedDelivery();
        if (!isDefined(delivery)) {
            return;
        }

        const modalInstance = this.modalService.show(SmartlockerAccessCodeComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_MEDIUM,
            initialState: {
                smartlockerId: delivery.SmartlockerId,
                smartlockerDoorId: delivery.SmartlockerDoorId,
            },
            ariaLabelledBy: 'smartlocker-access-code-title',
        });

        modalInstance.content?.modalResult.pipe(take(1)).subscribe((result) => {
            if (result.length > 0) {
                this.modalService.show(SmartlockerTransferComponent, {
                    backdrop: 'static',
                    class: ModalClass.MODAL_MEDIUM,
                    initialState: {
                        material: material,
                    },
                    ariaLabelledBy: 'smartlocker-transfer-title',
                });
            }
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
